<template>
  <Panel lineColor="var(--primary-color)" class="text-start">
    <v-row class="align-center">
      <v-col>
        Para publicar o seu e-commerce é necessário realizar os passos abaixo:
      </v-col>
      <v-col cols="auto">
        <FormButton @click="$emit('open-store')" outlined>
          <v-img
            src="@/assets/icons/wizard/preview.png"
            max-width="24"
            class="mr-3"
          />
          Ver loja
        </FormButton>
      </v-col>
    </v-row>
    <v-divider class="mb-5"></v-divider>
    <v-row>
      <v-col v-for="(w, i) in wizardSteps" :key="i" cols="auto">
        <v-row no-gutters>
          <v-img
            :src="getIcon(w)"
            :style="getStyle(w)"
            class="step-icon"
            max-width="30"
            @click="navigate(w)"
          />
          <v-icon
            size="18"
            color="grey"
            class="ml-3 mr-n2"
            v-if="wizardSteps.length > i + 1"
          >
            fa-arrow-right
          </v-icon>
        </v-row>
      </v-col>
    </v-row>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";

export default {
  name: "WizardSteps",
  components: { Panel, FormButton },
  props: {
    wizardSteps: {
      type: Array,
      required: true
    }
  },
  methods: {
    getStyle(step) {
      if (!step) return {};
      const { query_resolucao } = step;
      return {
        color: query_resolucao ? "#F59612" : "",
        cursor: query_resolucao ? "pointer" : "default"
      };
    },
    getIcon(step) {
      if (!step) return "";
      const { query_resolucao } = step;
      const basePath = query_resolucao
        ? require(`@/assets/icons/wizard/a-${step.icone}.png`)
        : require(`@/assets/icons/wizard/${step.icone}.png`);
      return basePath;
    },
    navigate(step) {
      if (step.query_resolucao) {
        this.$emit("navigate", step);
      }
    }
  }
};
</script>
